import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Chip,
  CircularProgress,
  Stack,
  Button
} from '@mui/material';
import { Link } from "react-router-dom";
const PoliticsSection = () => {
  const [mounted, setMounted] = React.useState(false);
  const [politicsStories, setPoliticsStories] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  React.useEffect(() => {
    if (!mounted) return;
    
    const fetchPoliticsStories = async () => {
      try {
        const response = await fetch('https://ethioinsider-backend.onrender.com/api/articles/politics');
        if (!response.ok) {
          throw new Error('Failed to fetch politics stories');
        }
        const result = await response.json();
        if (result.data && Array.isArray(result.data)) {
          setPoliticsStories(result.data.slice(0, 3));
        } else {
          throw new Error('Unexpected API response format');
        }
      } catch (err) {
        setError(err.message);
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPoliticsStories();
  }, [mounted]);

  if (!mounted) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography variant="body1" color="error" sx={{ textAlign: "center", py: 4 }}>
        Error loading politics stories: {error}
      </Typography>
    );
  }

  if (politicsStories.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center", py: 4 }}>
        No politics stories available at the moment.
      </Typography>
    );
  }

 return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid xs={12} md={8}>
          <Card square elevation={1} sx={{ height: "100%", minHeight: "400px" }}>
            <CardActionArea 
              component={Link} 
              to={`/articles/${politicsStories[0]?._id}`} 
              sx={{ height: "100%" }}
            >
              <CardMedia
                component="img"
                height="240"
                image={
                  politicsStories[0]?.imageUrl ||
                  "https://via.placeholder.com/800x450?text=Politics"
                }
                alt={politicsStories[0]?.title}
                sx={{ objectFit: "cover", width: "100%" }}
                onError={(e) => {
                  e.target.src = "https://via.placeholder.com/800x450?text=Politics";
                }}
              />
              <CardContent>
                <Chip label="Politics" color="primary" size="small" sx={{ mb: 1 }} />
                <Typography variant="h6" maxWidth="550px">
                  {politicsStories[0]?.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  paragraph
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    maxWidth:"500px"
                  }}
                >
                  {politicsStories[0]?.excerpt || "No excerpt available"}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {new Date(politicsStories[0]?.createdAt).toLocaleDateString()}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid xs={12} md={4}>
          <Stack spacing={2} sx={{ height: "100%" }}>
            {politicsStories.slice(1, 3).map((story) => (
              <Card 
                key={`politics-${story._id}`} 
                square 
                elevation={1}
                sx={{ height: "calc(50% - 8px)" }}
              > 
                <CardActionArea 
                  component={Link} 
                  to={`/article/${story._id}`} 
                  sx={{ height: "100%" }}
                >
                  <CardMedia
                    component="img"
                    height="140"
                    image={
                      story?.imageUrl ||
                      "https://via.placeholder.com/400x250?text=Politics"
                    }
                    alt={story?.title}
                    sx={{ 
                      objectFit: "cover",
                      width: "100%",
                      height: "140px" 
                    }}
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/400x250?text=Politics";
                    }}
                  />
                  <CardContent>
                    <Typography 
                      variant="subtitle1" 
                      gutterBottom
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        minHeight: "3em"
                      }}
                    >
                      {story?.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {new Date(story?.createdAt).toLocaleDateString()}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Stack>
        </Grid>
      </Grid>

      {politicsStories.length >= 3 && (
        <Box textAlign="center" sx={{ mt: 2 }}>
          <Button 
            variant="outlined" 
            component={Link} 
            to="/politics-news"
          >
            View All Politics News
          </Button>
        </Box>
      )}
    </>
  );
};
  

export default PoliticsSection;